const styles = () => ({
  '& > div': {
    // Fixes a double scrolling bug applied by pdf.js framework
    overflowY: 'hidden !important',
  },
  height: '100%',
  minHeight: 0,
});

export default styles;
